import {Action} from '@ngrx/store';
import {type} from '../utils/type';
import {CATEGORY} from '../common/category.common';

export interface IOrderActions {
    SET_UUID: string;
}

export const ActionTypes: IOrderActions = {
    SET_UUID: type(`${CATEGORY} Set uuid`)
};

export class SetUuidAction implements Action {
    type = ActionTypes.SET_UUID;
    constructor(public payload: string) {}
}

export type Actions = SetUuidAction
